import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-employee-routes',
  templateUrl: './employee-routes.component.html',
  styleUrls: ['./employee-routes.component.css']
})
export class EmployeeRoutesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/components/employee-routes/employee-routes.component.ts